;(function () {
  angular
    .module('contrast.password')
    .controller('ProfilePasswordCtrl', ProfilePasswordCtrl)

  function ProfilePasswordCtrl($scope, logger, ProfileFactory, ErrorService) {
    'ngInject'

    angular.extend($scope, {
      profile: {
        currentpassword: '',
        newpassword: '',
        confirmpassword: '',
        passwordvalid: false
      }
    })

    angular.extend($scope, {
      save: save
    })

    function save() {
      ProfileFactory.updatePasswordProfile(
        $scope.profile.currentpassword,
        $scope.profile.newpassword
      )
        .then(function (response) {
          logger.logSuccess(response.data.messages[0])
          _resetForm()
        })
        .catch(ErrorService.processError)
    }

    function _resetForm() {
      $scope.profile = {}
      $scope.form.$setPristine()
    }
  }
})()
